import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createRootReducer from '../reducers';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (history) => {
  return createStore(
    createRootReducer(),
    composeEnhancer(applyMiddleware(thunk.withExtraArgument(history))),
  );
};
